import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FIBInput from "../Form/FIBInput";
export default {
  name: 'FibComments',
  components: {
    'fib-input': FIBInput
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 1
    },
    value: {
      type: [String, Boolean, Array],
      default: ''
    },
    isPostcodeField: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hint: '',
      isMaxCharactersReached: false
    };
  },
  methods: {
    handleKeyup: function handleKeyup(event) {
      // When the character limit of 10 is reached, isMaxCharactersReached is set to true, if another character is entered whilst this is true then it'll display the hint below.
      if (this.isPostcodeField) {
        if (this.isMaxCharactersReached && event.target.value.length === 10) {
          this.hint = this.$tc('common.validation.max', 10);
        } else {
          this.isMaxCharactersReached = false;
          this.hint = '';
        }

        if (event.target.value.length === 10) {
          this.isMaxCharactersReached = true;
        }
      }
    }
  }
};